// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from '@/store'
import './lang'
import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'
import './assets/theme.scss'
import '@/assets/scss/custom/theme.scss'
import Paginate from 'vuejs-paginate'
// Plugins
import GlobalComponents from './globalComponents'
import GlobalDirectives from './globalDirectives'
import MaterialDashboard from './material-dashboard'
import MaterialIcon from 'material-design-icons'

Vue.use(VueMaterial)
Vue.use(MaterialDashboard)
Vue.use(GlobalComponents)
Vue.use(GlobalDirectives)

Vue.component('paginate', Paginate)
Vue.component('material-icon', MaterialIcon)

Vue.config.productionTip = false
require('@/config/index')

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js